// 自動生成するパスワードの構成
const DEFAULT_PASSWORD_LENGTH = 8;
const PASSWORD_UPPER_CHARS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const PASSWORD_LOWER_CHARS = "abcdefghijklmnopqrstuvwxyz";
const PASSWORD_NUMBER_CHARS = "0123456789";

// 0以上max未満の乱数を取得する
// 剰余による偏りを避けるため、maxの倍数に収まらない値は引き直す
const GetRandomInt = (max) => {
    const limit = Math.floor(256 / max) * max;
    const randomValues = new Uint8Array(1);
    let value = limit;
    while (value >= limit) {
        window.crypto.getRandomValues(randomValues);
        value = randomValues[0];
    }
    return value % max;
};

// パスワードを自動生成する
// 大文字・小文字・数字を必ず1文字ずつ含めたうえで、残りを3種から埋めて並びをシャッフルする
export const generatePassword = (length = DEFAULT_PASSWORD_LENGTH) => {
    const allChars = PASSWORD_UPPER_CHARS + PASSWORD_LOWER_CHARS + PASSWORD_NUMBER_CHARS;

    const chars = [
        PASSWORD_UPPER_CHARS[GetRandomInt(PASSWORD_UPPER_CHARS.length)],
        PASSWORD_LOWER_CHARS[GetRandomInt(PASSWORD_LOWER_CHARS.length)],
        PASSWORD_NUMBER_CHARS[GetRandomInt(PASSWORD_NUMBER_CHARS.length)],
    ];

    while (chars.length < length) {
        chars.push(allChars[GetRandomInt(allChars.length)]);
    }

    // 先頭3文字の種類が固定されないよう並びを入れ替える
    for (let i = chars.length - 1; i > 0; i--) {
        const j = GetRandomInt(i + 1);
        const temp = chars[i];
        chars[i] = chars[j];
        chars[j] = temp;
    }

    return chars.join("");
};
